import { AlertService, MessageType } from "prettyneat-vue";

const alertService = new AlertService()

export { MessageType };
export default alertService;